import React from "react";
import { DProductsFilters } from "./filters";
import { DProductInfoActions } from "./actions";
import { Plural, t, Trans } from "@lingui/macro";
import { PopupAdd } from "./popupContents/popupAdd";
import { TableBody, TableHeader } from "./tableData";
import { PopupEdit } from "./popupContents/popupEdit";
import { PopupDetails } from "./popupContents/popupDetails";
import { PopupAddToEdm } from "./popupContents/popupAddToEdm";
import { DashboardContentPage } from "../DashboardContentTable";
import { PopupChangeVAT } from "./popupContents/popupChangeVAT";
import { PopupImportProducts } from "./popupContents/popupImport";
import { PopupBulkOffSale } from "./popupContents/popupBulkOffSale";
import { InputSearch } from "components/UI/InputSearch/InputSearch";
import { FiltersDashboard } from "../DashboardContentTable/FiltersDashboard";
import { DataTableDashboard } from "../DashboardContentTable/DataTableDashboard";
import { PopupBulkChangeCategory } from "./popupContents/popupBulkChangeCategory";
import { PopupPanelDashboard } from "../DashboardContentTable/PopupPanelDashboard";
import { IdProductsStateDataItem } from "model/dashboardProducts/dProductsReducer";
import { PopupDeleteAllFromStores } from "./popupContents/popupDeleteAllFromStores";
import { PopupBulkDeleteFromStores } from "./popupContents/popupBulkDeleteFromStores";
import { ConfirmDialogDashboard } from "../DashboardContentTable/ConfirmDialogDashboard";
import { PopupExportProducts } from "components/containers/dashboard/dataProducts/popupContents/popupExport";
import { typePaginationDashboardObject } from "../DashboardContentTable/PaginationDashboard/PaginationDashboard";
import {
  typeDataProductInfoRowActions,
  typeDataProductInfoBulkActions,
} from "./index";
import {
  USERPOSITIONS,
  POSITION_ALLOW_FULL_CRUD_PRODUCTS,
} from "constants/userPositions";

export type typeViewDataProductInfo = {
  variant?: string;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;

  onClickAdd: () => void;
  onClickImport: () => void;
  onClickExport: () => void;
  onClickChangeVAT: () => void;

  openPopupEdm: boolean;
  setOpenPopupEdm: React.Dispatch<React.SetStateAction<boolean>>;

  openFilterBar: boolean;
  setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>;

  openPopupImport: boolean;
  setOpenPopupImport: React.Dispatch<React.SetStateAction<boolean>>;

  openPopupDetails: boolean;
  setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>;

  openPopupAdd: boolean;
  setOpenPopupAdd: React.Dispatch<React.SetStateAction<boolean>>;

  openPopupEdit: boolean;
  setOpenPopupEdit: React.Dispatch<React.SetStateAction<boolean>>;

  openPopupExport: boolean;
  setOpenPopupExport: React.Dispatch<React.SetStateAction<boolean>>;
  openDeleteDialog: boolean;
  setOpenDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>;
  onDeleteConfirmHandler: () => void;
  onDeleteCancelHandler: () => void;

  openRecoverDialog: boolean;
  setOpenRecoverDialog: React.Dispatch<React.SetStateAction<boolean>>;
  onRecoverConfirmHandler: () => void;
  onRecoverCancelHandler: () => void;

  openPopupBulkChangeCategory: boolean;
  setOpenPopupBulkChangeCategory: React.Dispatch<React.SetStateAction<boolean>>;

  openPopupBulkOffSale: boolean;
  setOpenPopupBulkOffSale: React.Dispatch<React.SetStateAction<boolean>>;

  openPopupBulkDeleteFromStores: boolean;
  setOpenPopupBulkDeleteFromStores: React.Dispatch<
    React.SetStateAction<boolean>
  >;

  openBulkDeleteDialog: boolean;
  setBulkOpenDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>;
  onBulkDeleteConfirmHandler: () => void;
  onBulkDeleteCancelHandler: () => void;
  deleteCount: number;

  openDeleteAllDialog: boolean;
  setOpenDeleteAllDialog: React.Dispatch<React.SetStateAction<boolean>>;
  onDeleteAllConfirmHandler: () => void;
  onDeleteAllCancelHandler: () => void;

  openChangeVATDialog: boolean;
  setOpenChangeVATDialog: React.Dispatch<React.SetStateAction<boolean>>;

  openBulkRecoveryDialog: boolean;
  setOpenBulkRecoveryDialog: React.Dispatch<React.SetStateAction<boolean>>;
  onBulkRecoveryCancelHandler: () => void;
  onBulkRecoveryConfirmHandler: () => void;

  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
  onChangeSearchValue: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
  onEnterSearch: () => void;
  onClearSearch: () => void;

  rowsActions: typeDataProductInfoRowActions;
  bulkActions: typeDataProductInfoBulkActions;

  currentItem: IdProductsStateDataItem | undefined;

  pagination: typePaginationDashboardObject;
  isActiveFilters: boolean;
  setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>;
  position: USERPOSITIONS | string;
};

export const ViewDataProductInfo: React.FC<typeViewDataProductInfo> = ({
  variant,
  setSidebarOpen,
  onClickAdd,
  onClickImport,
  onClickExport,
  onClickChangeVAT,
  openFilterBar,
  setOpenFilterBar,
  openPopupImport,
  setOpenPopupImport,
  openPopupDetails,
  setOpenPopupDetails,
  openPopupAdd,
  setOpenPopupAdd,
  openPopupEdit,
  setOpenPopupEdit,
  openPopupExport,
  setOpenPopupExport,
  openDeleteDialog,
  setOpenDeleteDialog,
  onDeleteConfirmHandler,
  onDeleteCancelHandler,
  openRecoverDialog,
  setOpenRecoverDialog,
  onRecoverConfirmHandler,
  onRecoverCancelHandler,
  openPopupBulkChangeCategory,
  setOpenPopupBulkChangeCategory,
  openPopupBulkOffSale,
  setOpenPopupBulkOffSale,
  openPopupBulkDeleteFromStores,
  setOpenPopupBulkDeleteFromStores,
  openBulkDeleteDialog,
  setBulkOpenDeleteDialog,
  onBulkDeleteConfirmHandler,
  onBulkDeleteCancelHandler,
  deleteCount,
  openDeleteAllDialog,
  setOpenDeleteAllDialog,
  openChangeVATDialog,
  setOpenChangeVATDialog,
  openBulkRecoveryDialog,
  setOpenBulkRecoveryDialog,
  onBulkRecoveryConfirmHandler,
  onBulkRecoveryCancelHandler,
  searchValue,
  setSearchValue,
  onChangeSearchValue,
  onClearSearch,
  onEnterSearch,
  rowsActions,
  bulkActions,
  currentItem,
  pagination,
  isActiveFilters,
  setIsActiveFilters,
  position,
  setOpenPopupEdm,
  openPopupEdm,
}) => {
  return (
    <DashboardContentPage
      setSidebarOpen={setSidebarOpen}
      headerTitle={<Trans>Products</Trans>}
      actions={
        <DProductInfoActions
          onClickAdd={
            POSITION_ALLOW_FULL_CRUD_PRODUCTS.includes(
              position as USERPOSITIONS
            )
              ? onClickAdd
              : undefined
          }
          onClickImport={
            POSITION_ALLOW_FULL_CRUD_PRODUCTS.includes(
              position as USERPOSITIONS
            )
              ? onClickImport
              : undefined
          }
          onClickExport={onClickExport}
          onClickChangeVAT={
            POSITION_ALLOW_FULL_CRUD_PRODUCTS.includes(
              position as USERPOSITIONS
            )
              ? onClickChangeVAT
              : undefined
          }
          onClickDeleteAll={
            POSITION_ALLOW_FULL_CRUD_PRODUCTS.includes(
              position as USERPOSITIONS
            )
              ? () => setOpenDeleteAllDialog(true)
              : undefined
          }
        />
      }
    >
      <FiltersDashboard
        variant={variant}
        isActiveFilters={isActiveFilters}
        filters={{
          filtersForm: (
            <DProductsFilters
              setOpenFilterBar={setOpenFilterBar}
              setIsActiveFilters={setIsActiveFilters}
            />
          ),
          openFilterBar: openFilterBar,
          setOpenFilterBar: setOpenFilterBar,
        }}
        searchBar={
          <InputSearch
            id="productSearch"
            name="productSearch"
            value={searchValue}
            onClear={onClearSearch}
            onKeyEnterDown={onEnterSearch}
            onChange={onChangeSearchValue}
            placeholder={t`Search by product's name`}
          />
        }
      />

      <DataTableDashboard
        pagination={pagination}
        tableHeader={<TableHeader bulkOperations={bulkActions} />}
        tableBody={
          <TableBody
            variant={variant}
            rowsActions={rowsActions}
            setOpenPopupDetails={setOpenPopupDetails}
          />
        }
      />

      <PopupPanelDashboard
        variant={variant}
        openPopup={openPopupImport}
        setOpenPopup={setOpenPopupImport}
        title={<Trans>Import products</Trans>}
      >
        <PopupImportProducts
          variant={variant}
          setOpenPopup={setOpenPopupImport}
        />
      </PopupPanelDashboard>

      <PopupPanelDashboard
        variant={variant}
        openPopup={openPopupDetails}
        setOpenPopup={setOpenPopupDetails}
        title={<Trans>Product details</Trans>}
      >
        <PopupDetails
          openPopupEdit={setOpenPopupEdit}
          setOpenPopupEdm={setOpenPopupEdm}
          setOpenPopup={setOpenPopupDetails}
          openDeleteDialog={setOpenDeleteDialog}
        />
      </PopupPanelDashboard>

      <PopupPanelDashboard
        variant={variant}
        openPopup={openPopupEdm}
        setOpenPopup={setOpenPopupEdm}
        title={<Trans>Add product</Trans>}
      >
        <PopupAddToEdm setOpenPopup={setOpenPopupEdm} />
      </PopupPanelDashboard>

      <PopupPanelDashboard
        variant={variant}
        openPopup={openPopupAdd}
        setOpenPopup={setOpenPopupAdd}
        title={<Trans>Add product</Trans>}
      >
        <PopupAdd setOpenPopup={setOpenPopupAdd} />
      </PopupPanelDashboard>

      <PopupPanelDashboard
        variant={variant}
        openPopup={openPopupEdit}
        setOpenPopup={setOpenPopupEdit}
        title={<Trans>Edit product</Trans>}
      >
        <PopupEdit
          setOpenPopup={setOpenPopupEdit}
          setSearchValue={setSearchValue}
          setOpenFilterBar={setOpenFilterBar}
          setIsActiveFilters={setIsActiveFilters}
        />
      </PopupPanelDashboard>

      <PopupPanelDashboard
        variant={variant}
        title={<Trans>Change category</Trans>}
        openPopup={openPopupBulkChangeCategory}
        setOpenPopup={setOpenPopupBulkChangeCategory}
      >
        <PopupBulkChangeCategory
          setOpenPopup={setOpenPopupBulkChangeCategory}
        />
      </PopupPanelDashboard>

      <PopupPanelDashboard
        variant={variant}
        title={<Trans>Off sale</Trans>}
        openPopup={openPopupBulkOffSale}
        setOpenPopup={setOpenPopupBulkOffSale}
      >
        <PopupBulkOffSale setOpenPopup={setOpenPopupBulkOffSale} />
      </PopupPanelDashboard>

      <PopupPanelDashboard
        variant={variant}
        title={<Trans>Delete from stores</Trans>}
        openPopup={openPopupBulkDeleteFromStores}
        setOpenPopup={setOpenPopupBulkDeleteFromStores}
      >
        <PopupBulkDeleteFromStores
          setOpenPopup={setOpenPopupBulkDeleteFromStores}
        />
      </PopupPanelDashboard>

      <ConfirmDialogDashboard
        variant={variant}
        type="error"
        openDialog={openDeleteDialog}
        setOpenDialog={setOpenDeleteDialog}
        title={<Trans>Delete product</Trans>}
        message={
          <Trans>
            Do you really want delete product <b>{currentItem?.name}</b>?
          </Trans>
        }
        primaryButton={{
          title: <Trans>Delete</Trans>,
          action: onDeleteConfirmHandler,
        }}
        secondaryButton={{
          title: <Trans>Cancel</Trans>,
          action: onDeleteCancelHandler,
        }}
      />

      <ConfirmDialogDashboard
        variant={variant}
        type="info"
        openDialog={openRecoverDialog}
        setOpenDialog={setOpenRecoverDialog}
        title={<Trans>Recover product</Trans>}
        message={
          <Trans>
            Do you really want recover product <b>{currentItem?.name}</b>?
          </Trans>
        }
        primaryButton={{
          title: <Trans>Recover</Trans>,
          action: onRecoverConfirmHandler,
        }}
        secondaryButton={{
          title: <Trans>Cancel</Trans>,
          action: onRecoverCancelHandler,
        }}
      />

      <ConfirmDialogDashboard
        variant={variant}
        type="info"
        openDialog={openBulkRecoveryDialog}
        title={<Trans>Recover products</Trans>}
        setOpenDialog={setOpenBulkRecoveryDialog}
        message={<Trans>Do you really want recover selected products ?</Trans>}
        primaryButton={{
          title: <Trans>Recover</Trans>,
          action: onBulkRecoveryConfirmHandler,
        }}
        secondaryButton={{
          title: <Trans>Cancel</Trans>,
          action: onBulkRecoveryCancelHandler,
        }}
      />

      <ConfirmDialogDashboard
        variant={variant}
        type="error"
        title={<Trans>Delete products</Trans>}
        message={
          <>
            <Trans>Do you really want delete</Trans> <b>{deleteCount}</b>{" "}
            <Plural
              value={deleteCount}
              one={"product"}
              _2={"products"}
              _3={"products"}
              _4={"products"}
              other={"products"}
            />
            ?
          </>
        }
        primaryButton={{
          title: <Trans>Delete</Trans>,
          action: onBulkDeleteConfirmHandler,
        }}
        secondaryButton={{
          title: <Trans>Cancel</Trans>,
          action: onBulkDeleteCancelHandler,
        }}
        openDialog={openBulkDeleteDialog}
        setOpenDialog={setBulkOpenDeleteDialog}
      />

      <PopupPanelDashboard
        variant={variant}
        title={<Trans>Delete all products</Trans>}
        openPopup={openDeleteAllDialog}
        setOpenPopup={setOpenDeleteAllDialog}
      >
        <PopupDeleteAllFromStores setOpenPopup={setOpenDeleteAllDialog} />
      </PopupPanelDashboard>

      <PopupPanelDashboard
        variant={variant}
        openPopup={openChangeVATDialog}
        title={<Trans>Change VAT</Trans>}
        setOpenPopup={setOpenChangeVATDialog}
      >
        <PopupChangeVAT setOpenPopup={setOpenChangeVATDialog} />
      </PopupPanelDashboard>

      <PopupPanelDashboard
        variant={variant}
        openPopup={openPopupExport}
        setOpenPopup={setOpenPopupExport}
        title={<Trans>Export product's list</Trans>}
      >
        <PopupExportProducts setOpenPopup={setOpenPopupExport} />
      </PopupPanelDashboard>
    </DashboardContentPage>
  );
};
